import ModelScoringSummaryMetrics from './ModelScoringSummaryMetrics';
import ValueClassCompositionBar from './ValueClassCompositionBar';
import { Box } from '@mui/material';
import { buildValueClassCompositionPreview } from './buildValueClassCompositionPreview';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import type { ValueCompositionRow } from '../../types/modelScoring';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
    },
  })
);

export interface ModelScoringValueInsightsProps {
  valueCompositions?: ValueCompositionRow[] | null;
  lalModelPrecision: number;
}

/**
 * Value-class composition + summary metrics from audience API `valueCompositions`.
 */
const ModelScoringValueInsights = ({
  valueCompositions,
  lalModelPrecision,
}: ModelScoringValueInsightsProps) => {
  const classes = useStyles();
  const data = useMemo(
    () =>
      buildValueClassCompositionPreview(valueCompositions, lalModelPrecision),
    [valueCompositions, lalModelPrecision]
  );

  return (
    <Box className={classes.root}>
      <ValueClassCompositionBar data={data} />
      <ModelScoringSummaryMetrics data={data} />
    </Box>
  );
};

export default ModelScoringValueInsights;
